/**
 * Application Constants
 * Centralized place for version numbers and asset versioning
 * 
 * HOW TO UPDATE IMAGES AND VIDEOS:
 * =================================
 * When you update any of these assets in the public folder:
 * 1. Replace the files in /public/ or /public/hls/ (keep the same filenames)
 * 2. Increment the corresponding version number below (e.g., '1.0.0' -> '1.0.1')
 * 3. Rebuild and redeploy the site
 * 
 * The version query parameter (?v=1.0.1) forces browsers to fetch the new asset
 * instead of using their cached version.
 * 
 * IMPORTANT: For videos, incrementing the version tells the deployment script to 
 * re-upload ALL files for that video (master.m3u8, poster, fallback MP4, and all 
 * quality variants v0/v1/v2) to S3. If the version hasn't changed, the deployment 
 * will skip uploading to save time and bandwidth.
 * 
 * Assets in /public/ folder:
 * - Solidly Finance App.png                    -> HERO_IMAGE
 * - og-image.jpg                               -> OG_IMAGE (Facebook/LinkedIn share preview)
 * - twitter-image.jpg                          -> TWITTER_IMAGE (Twitter share preview)
 * - hls/demo/                                  -> DEMO_VIDEO (includes master.m3u8, poster, fallback MP4, v0/v1/v2)
 * - hls/walkthroughs/001/                      -> WALKTHROUGH_001 (includes master.m3u8, poster, fallback MP4, v0/v1/v2)
 */

// Asset versions for cache busting
// Increment these when you update the corresponding assets
export const ASSET_VERSIONS = {
  HERO_IMAGE: '1.0.2',       // Main hero screenshot on homepage
  OG_IMAGE: '1.0.0',         // Open Graph image for social sharing
  TWITTER_IMAGE: '1.0.0',    // Twitter card image
  DEMO_VIDEO: '1.0.1',       // Demo video - entire hls/demo/ directory (master.m3u8, poster, fallback MP4, v0/v1/v2)
  WALKTHROUGH_001: '1.0.1',  // Walkthrough 001 - entire hls/walkthroughs/001/ directory (master.m3u8, poster, fallback MP4, v0/v1/v2)
};

// Helper function to get versioned asset URL
export const getVersionedAsset = (path, version = null) => {
  if (version) {
    return `${path}?v=${version}`;
  }
  return path;
};
